import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { API_URL } from '../models/api-url.token';
import { IQuestionReviewUm } from '../question-review-um.model';
import { IQuestionReviewVm } from '../question-review-vm.model';

/** PUT /QuestionReview: raise or clear the "do sprawdzenia" flag of one question. */
@Injectable({ providedIn: 'root' })
export class QuestionReviewService {
  private readonly baseUrl: string;
  constructor(private http: HttpClient, @Inject(API_URL) private apiUrl: string) {
    this.baseUrl = `${this.apiUrl}/QuestionReview`;
  }
  put(um: IQuestionReviewUm): Observable<IQuestionReviewVm> {
    const headers = this.createHeaders();
    return this.http.put<IQuestionReviewVm>(this.baseUrl, um, { headers });
  }
  private createHeaders(): HttpHeaders {
    let headers = new HttpHeaders();
    const token = localStorage.getItem('authToken');
    if (token) headers = headers.set('Authorization', `Bearer ${token}`);
    return headers;
  }
}
